/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ConsultaInconsistenciaSibAliases {
  CONTEXTUAL_BAR_INCONSISTENCIAS_SIB = 'contextual-bar-inconsistencias-sib',
  DECK_0 = 'deck-0',
  FETCH_CONSULTA = 'fetch-consulta',
  FIELD_0 = 'field-0',
  FIELD_BENEFICIARIO = 'field-beneficiario',
  FIELD_CARTEIRA = 'field-carteira',
  FIELD_TITULARIDADE = 'field-titularidade',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_DYNAMIC_CONTENT_ALTERACAO = 'hpms-dynamic-content-alteracao',
  HPMS_DYNAMIC_CONTENT_VISUALIZACAO = 'hpms-dynamic-content-visualizacao',
  LOCATOR_0 = 'locator-0',
  PANEL_INCONSISTENCIAS_SIB = 'panel-inconsistencias-sib',
  TEXT_BENEFICIARIO = 'text-beneficiario',
  TEXT_CARTEIRA = 'text-carteira',
  TEXT_TITULARIDADE = 'text-titularidade',
}
export { ConsultaInconsistenciaSibAliases };
